import PropTypes from 'prop-types';
import { Search, X } from 'react-feather';

/** Caja de búsqueda de las tablas estándar, con un hueco a la derecha para acciones de la pantalla. */
const BarraBusqueda = ({
  busqueda,
  onChange,
  placeholder = 'Buscar…',
  nombreEntidad,
  barraExtra = null,
}) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      flexWrap: 'wrap',
      backgroundColor: '#fff',
      border: '1px solid #e5e7eb',
      borderRadius: '12px',
      padding: '12px 16px',
      boxShadow: '0 1px 3px rgb(0 0 0 / 0.06)',
    }}
  >
    <div style={{ position: 'relative', flex: '1 1 320px', maxWidth: 560 }}>
      <Search size={15} style={{ position: 'absolute', left: 10, top: 10, color: '#9ca3af' }} />
      <input
        type="search"
        value={busqueda}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={`Buscar ${nombreEntidad}`}
        style={{
          width: '100%',
          padding: '7px 30px 7px 32px',
          fontSize: '0.8125rem',
          border: '1px solid #e5e7eb',
          borderRadius: '8px',
          background: '#fff',
        }}
      />
      {busqueda && (
        <button
          type="button"
          aria-label="Borrar búsqueda"
          onClick={() => onChange('')}
          style={{
            position: 'absolute',
            right: 6,
            top: 6,
            border: 0,
            background: 'none',
            color: '#9ca3af',
            cursor: 'pointer',
          }}
        >
          <X size={15} />
        </button>
      )}
    </div>
    {barraExtra && <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>{barraExtra}</div>}
  </div>
);

BarraBusqueda.propTypes = {
  busqueda: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  nombreEntidad: PropTypes.string.isRequired,
  barraExtra: PropTypes.node,
};

export default BarraBusqueda;
